module.exports = __webpack_public_path__ + "img/arkit.74b2064f.png";